import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

// Section rendering can replace the drawer instance while it is open.
let cartReturnFocus = null;

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.cartDialog = this.refs.dialog;
    this.cartDialog.addEventListener('close', this.#restoreFocus);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.cartDialog?.removeEventListener('close', this.#restoreFocus);
  }

  #handleCartAdd = (event) => {
    // Quantity edits/removals refresh the cart but must not reopen a closed drawer.
    if (!(event instanceof CartAddEvent) || event.detail?.data?.didError || event.detail?.data?.openDrawer === false) return;
    if (this.hasAttribute('auto-open')) {
      cartReturnFocus = event.target?.closest?.('product-form-component, [data-ci-product]')?.querySelector('button[name=add]');
      this.showDialog();
    }
  };

  #restoreFocus = () => {
    // Native Escape can close a dialog whose contents were replaced by a cart refresh.
    if (document.body.style.position === 'fixed' && !document.querySelector('dialog[open]')) {
      const scrollY = -parseFloat(document.body.style.top) || 0;
      document.body.style.width = '';
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo({top: scrollY, behavior: 'instant'});
    }
    const target = cartReturnFocus?.isConnected ? cartReturnFocus
      : document.querySelector('[data-ci-product] button[name=add]') || this.querySelector('[data-testid=cart-drawer-trigger]');
    if (target && !target.disabled) target.focus({preventScroll:true});
  };

  open() {
    cartReturnFocus = this.querySelector('[data-testid=cart-drawer-trigger]');
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
